<template>
    <div
        ref="homeBanner"
        class="col-12 w-100 px-0 mx-0 d-flex main-image-wrapper home-banner"
    >
        <div
            v-if="isLoading"
            class="home-banner__loading"
        >
            <van-loading
                type="spinner"
                color="#E76229"
                class="mx-auto"
            />
        </div>
        <b-carousel
            v-else
            id="carousel-1"
            :interval="3000"
            controls
            fade
            class="home-banner__carousel w-100"
        >
            <b-carousel-slide
                v-for="banner in banners"
                :key="banner.id"
                :img-src="banner.image"
            />
        </b-carousel>
    </div>
</template>

<script>
import { Loading } from 'vant';
import promo1 from '@/assets/promo1.png';

const MOCK_BANNERS = [
    { id: 'mock-1', image: 'https://storage.googleapis.com/spacetech2/thingaha/promo1.avif' },
    { id: 'mock-2', image: promo1 },
    { id: 'mock-3', image: 'https://storage.googleapis.com/spacetech2/thingaha/promo3.avif' },
];

export default {
    name: 'HomeBanner',
    components: { [Loading.name]: Loading },
    data() {
        return {
            isLoading: true,
            banners: MOCK_BANNERS,
        };
    },
    async mounted() {
        await this.fetchBanners();

        const isDesktopFinePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
        if (isDesktopFinePointer) {
            this.$nextTick(() => {
                this.setupDesktopBannerWheel();
            });
        }
    },
    beforeDestroy() {
        this.teardownDesktopBannerWheel();
    },
    methods: {
        async fetchBanners() {
            try {
                this.isLoading = true;
                const res = await axios.get('/banners');
                const apiBanners = (res.data?.data || []).filter((banner) => banner.image);

                this.banners = apiBanners.length > 0 ? apiBanners : MOCK_BANNERS;
            } catch (error) {
                console.log(error);
                this.banners = MOCK_BANNERS;
            } finally {
                this.isLoading = false;
            }
        },
        setupDesktopBannerWheel() {
            const banner = this.$refs.homeBanner;
            if (!banner) return;

            this._onHomeBannerWheel = (event) => {
                const scrollContainer = banner.closest('.home-lobby')?.querySelector('.index_rightbar')
                    || banner.closest('.index-scroll-main');
                if (!scrollContainer) return;

                scrollContainer.scrollTop += event.deltaY;
                event.preventDefault();
            };

            banner.addEventListener('wheel', this._onHomeBannerWheel, { passive: false });
            this._homeBannerWheelEl = banner;
        },
        teardownDesktopBannerWheel() {
            if (this._homeBannerWheelEl && this._onHomeBannerWheel) {
                this._homeBannerWheelEl.removeEventListener('wheel', this._onHomeBannerWheel);
                this._homeBannerWheelEl = null;
                this._onHomeBannerWheel = null;
            }
        },
    },
};
</script>

<style scoped>
.home-banner {
    max-width: 100%;
    overflow: hidden;
    background: #12101C;
}

.home-banner__carousel {
    width: 100%;
    height: auto;
}

.home-banner__loading {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 180px;
    background: #12101C;
}

.home-banner ::v-deep .carousel,
.home-banner ::v-deep .carousel-inner,
.home-banner ::v-deep .carousel-item {
    background: #12101C !important;
    border-radius: 0 !important;
    height: auto !important;
}

.home-banner ::v-deep .carousel-item img,
.home-banner ::v-deep img {
    width: 100%;
    height: auto !important;
    display: block;
    border-radius: 0 !important;
}

@media (hover: hover) and (pointer: fine) {
    .home-banner {
        touch-action: pan-y;
    }
}
</style>
